import Apify from '@module/apify';

export default Apify({
  load: {
    path: '/api/v4/studio-wallpapers/{advertId}',
    pathExt: true,
  },
});
